import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import React from "react";

type Props = {
    open: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    text: string
}

const PageLeaveConfirmationDialog : React.FC<Props> = ({text, open, onCancel, onConfirm}) => {

   return (
      <Dialog
         open={open}
         title="Warning"
      >
          <DialogTitle>
            {text}
          </DialogTitle>
          <DialogContent>
              {/* <Typography>{text}</Typography> */}
          </DialogContent>
          <DialogActions>
              <Grid item />
                <Grid item>
                    <Button variant='text' color='secondary' onClick={() => onCancel()}>Cancel</Button>
                </Grid>
                <Grid item>
                    <Button variant='contained' color='primary' onClick={() => onConfirm()}>Yes, I'm Sure</Button>
                </Grid>
          </DialogActions>
      </Dialog>
  )
};

export default PageLeaveConfirmationDialog;